import { useParams } from 'react-router-dom';
import {useEffect} from 'react';
// need to query download db to verify endpoint has token 
// get email from download query to automatically pass to download 
function Music(){
const {password} = useParams();

useEffect(()=> {
    async function Download(){
            // frontend to display list of links
            try{
                const res = await fetch(`/music/${encodeURIComponent(password)}`);
                if(!res.ok) throw new Error('Links didnt work'); else {
                const blob = await res.blob();
                const disposition = res.headers.get("Content-Disposition");
                let filename = 'songs.zip'; // fallback
                if (disposition && disposition.includes("filename=")) {
                filename = disposition.split("filename=")[1].replace(/"/g, "");
            }
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename; // or single file
                a.click();
                window.URL.revokeObjectURL(url);   
                    // Download
                }
            } catch(err) {console.error(err)}
        }
    if(password) Download();
}, [password]);
return (
    <>
    </>
)
}

export default Music;